var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyAlcoholNot = function SvgHappyAlcoholNot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF5F7",
    d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3A5C",
    d: "M6.75 5.5h1.5a.25.25 0 0 0 .25-.25V4.5A.5.5 0 0 0 8 4H7a.5.5 0 0 0-.5.5v.75a.25.25 0 0 0 .25.25M9.69 9l-.25-.15c-.485-.275-.94-.545-.94-.85V6.5a.25.25 0 0 0-.25-.25h-1.5a.25.25 0 0 0-.25.25V8c0 .305-.455.575-.94.86-.695.41-1.56.92-1.56 1.89.035 1.481.16 2.959.375 4.425a1 1 0 0 0 1 .825H9.09a.256.256 0 0 0 .248-.207.25.25 0 0 0-.008-.118 1.5 1.5 0 0 1-.065-.425v-1A.25.25 0 0 0 9 14H6a.25.25 0 0 1-.25-.25v-2A.25.25 0 0 1 6 11.5h3a.25.25 0 0 0 .25-.25v-.75a1.47 1.47 0 0 1 .5-1.09.27.27 0 0 0 .08-.21.26.26 0 0 0-.14-.2M15.125 9.75h-4.25a.88.88 0 0 0-.875.875v4A1.375 1.375 0 0 0 11.375 16h3.25A1.375 1.375 0 0 0 16 14.625v-4a.88.88 0 0 0-.875-.875M11.5 13.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1m1.25 1.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1m1.75-1.25a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1m.75-2.25a.25.25 0 0 1-.25.25h-4a.25.25 0 0 1-.25-.25v-.875a.125.125 0 0 1 .125-.125h4.25a.125.125 0 0 1 .125.125z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#happyAlcoholNot_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FF3A5C",
    strokeLinecap: "round",
    d: "M16 4.707 4.707 16"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "happyAlcoholNot_svg__a",
    width: 12.293,
    height: 13.293,
    x: 4.207,
    y: 3.207,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.960784 0 0 0 0 0.968627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_239"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3004_239",
    result: "shape"
  })))));
};
export default SvgHappyAlcoholNot;